export default __webpack_public_path__ + "static/media/Room.fc17f4bd.png";